<template>
  <BaseModal
    :onOpenHook="handleOpen"
    :onCloseHook="handleClose"
    :persistent="loading"
    minHeight="295px"
    modalWidth="600px"
    hookSufix="TwoFactorDisableModal"
    :title="
      typeDisable === 'app'
        ? $t('message.2fa.disableAuthenticationApp')
        : $t('message.2fa.disableSMS')
    "
    :contentClass="{
      'two-factor-disable-modal': true,
    }"
    :disableDefaultPadding="true"
  >
    <template #content>
      <v-row no-gutters class="mt-4">
        <v-col cols="12" class="text-center">
          <span class="body-bold-base">
            {{ $t('message.pages.login.2faModal.enterTempCode') }}
          </span>
        </v-col>
        <v-col cols="12" class="text-center">
          <span class="body-regular-small">
            {{ $t('message.pages.login.2faModal.enterSixDigits') }}
          </span>
        </v-col>
        <v-col cols="12" class="text-center mt-6 px-6">
          <v-otp-input
            ref="otpInput"
            v-model="code"
            :length="6"
            @finish="handleVerify"
            :disabled="loading"
            placeholder="0"
            :error="error"
            class="mfa-otp-input"
            type="number"
            autocomplete="one-time-code"
            @focusin="otpRememberIndex"
            @keydown.stop="otpHandleKeydown"
          ></v-otp-input>
        </v-col>
        <v-col cols="12" class="d-flex justify-center">
          <span
            class="body-regular-small feedback-danger--text mt-2"
            v-if="error"
          >
            {{ $t('message.pages.login.2faModal.invalidCode') }}
          </span>
          <LoadingSpinner v-show="loading" class="mt-6" />
        </v-col>
      </v-row>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal.vue'
import LoadingSpinner from '../BaseComponents/LoadingSpinner.vue'
import twoFactorAuthApi from '@/services/twoFactorAuthApi'
import otpInputHandler from '@/utils/TwoFactorAuthMixins/otpInputHandler.mixin.js'

export default {
  name: 'TwoFactorDisableModal',
  mixins: [otpInputHandler],
  components: {
    BaseModal,
    LoadingSpinner,
  },
  data: () => ({
    code: '',
    loading: false,
    error: false,
    onSuccessCallback: null,
    phoneNumber: '',
  }),
  props: {
    typeDisable: {
      type: String,
      required: false,
    },
    otpRef: { default: 'otpInput' },
    otpModelKey: { default: 'code' },
  },
  created() {},
  methods: {
    async handleOpen(data) {
      if (data.onSuccess) {
        this.onSuccessCallback = data.onSuccess
      }
      if (data.typeDisable) {
        this.typeDisable = data.typeDisable
      }

      if (this.typeDisable === 'sms') {
        try {
          await twoFactorAuthApi.phoneRequestCodeDisable()
        } catch (error) {
          console.log('Erro ao enviar código:', error)
        }
      }
      this.focusInput()
    },
    handleClose() {
      this.$emit('close')
    },

    async handleVerify() {
      try {
        this.error = false
        this.loading = true

        if (this.typeDisable === 'app') {
          await twoFactorAuthApi.mfaVerify({
            code: this.code,
          })
        } else if (this.typeDisable === 'sms') {
          await twoFactorAuthApi.disableSms(this.code)
        }

        if (this.onSuccessCallback) {
          await this.onSuccessCallback()
          this.$root.$emit('updateMfaStatus', false)
          this.$root.$emit('closeTwoFactorDisableModal')
        }
      } catch (error) {
        console.error('error', error)
        this.error = true
      } finally {
        this.loading = false
      }
    },
    focusInput() {
      this.$nextTick(() => {
        setTimeout(() => {
          const otpInput = this.$refs.otpInput
          if (otpInput?.focus) {
            otpInput.focus()
          } else {
            otpInput?.$el.querySelector('input')?.focus()
          }
        }, 100)
      })
    },
  },
}
</script>

<style lang="scss">
.two-factor-disable-modal {
  padding-bottom: 24px;
  .modal-header header {
    height: unset !important;
  }
  .v-toolbar__content {
    .spacer {
      display: none;
    }
    padding: 24px !important;
    display: flex;
    justify-content: space-between;
    .v-toolbar__title {
      margin: 0 auto !important;
    }

    .v-toolbar__items {
      i.v-icon {
        color: varFigma(neutral-70) !important;
      }
    }
  }

  .v-otp-input {
    .v-input {
      padding: 0 8px !important;

      .v-input__slot {
        margin: 0 !important;
      }
    }
  }
}

.mfa-otp-input {
  fieldset {
    border: 1px solid varFigma(neutral-95-lightest) !important;
  }
  input {
    color: varFigma(neutral-30-base) !important;

    &::placeholder {
      color: varFigma(neutral-60) !important;
    }
  }
  .error--text {
    fieldset {
      border: 1px solid varFigma(feedback-danger-light) !important;
      background-color: varFigma(feedback-danger-background) !important;
    }

    input {
      color: varFigma(feedback-danger-dark) !important;
    }
  }

  .v-input__control:has(input:focus) {
    fieldset {
      border: 2px solid varFigma(brand-60-base) !important;
    }
    input {
      color: varFigma(neutral-30-base) !important;
    }
  }
}

.two-factor-disable-modal {
  .theme--dark.v-otp-input .v-input .v-input__control .v-input__slot {
    background: transparent !important;
  }
}
</style>
